export type DirectionSlug = 'development' | 'ai-agents' | 'design' | 'smm' | 'marketing'

export type DirectionTheme = {
  accentRgb: string
  // Used specifically by the homepage "Directions" cards (legacy visual language).
  homeGradient?: string
}

const THEME_BY_SLUG: Record<DirectionSlug, DirectionTheme> = {
  development: {
    accentRgb: '59 130 246', // blue-500
    homeGradient: 'from-blue-600 via-blue-500 to-cyan-400',
  },
  'ai-agents': {
    // More saturated than violet so the hover glow is obvious on the dark background.
    accentRgb: '217 70 239', // fuchsia-500
    homeGradient: 'from-indigo-600 via-violet-500 to-fuchsia-400',
  },
  design: {
    accentRgb: '245 158 11', // amber-500
    homeGradient: 'from-amber-500 via-orange-500 to-yellow-500',
  },
  smm: {
    accentRgb: '236 72 153', // pink-500
    homeGradient: 'from-pink-500 via-rose-500 to-yellow-500',
  },
  marketing: {
    accentRgb: '74 222 128', // green-400
    homeGradient: 'from-green-400 via-emerald-500 to-teal-500',
  },
}

function isDirectionSlug(slug: string): slug is DirectionSlug {
  return slug in THEME_BY_SLUG
}

export function getDirectionTheme(slug: string | null | undefined): DirectionTheme {
  if (!slug) return { accentRgb: '255 255 255' }
  if (isDirectionSlug(slug)) return THEME_BY_SLUG[slug]
  return { accentRgb: '255 255 255' }
}
